import 'css-chunksrc/client/scenes/optimizedGantt/resources/resource/styles.scss';export default {
  "resource": "_resource_15rcn_1",
  "name": "_name_15rcn_7",
  "affiliation": "_affiliation_15rcn_18",
  "avatar": "_avatar_15rcn_29"
};